import fetch from 'auth/GenericFetchInterceptor'
import fetchV5 from 'auth/GenericFetchInterceptorV5'

const SchedaPazienteService = {}

let populateParamsPatient = "";
populateParamsPatient += "populate[0]=stores";
populateParamsPatient += "&populate[1]=visits";
populateParamsPatient += "&populate[2]=acquistis";
populateParamsPatient += "&populate[3]=purchases.sales_histories";
populateParamsPatient += "&populate[4]=sales_patients";
populateParamsPatient += "&populate[5]=state_type_patients.purchase";
populateParamsPatient += "&populate[6]=purchases.state_type_patient";
populateParamsPatient += "&populate[7]=devices.lot";
populateParamsPatient += "&populate[8]=devices.lot.product";
// Nuove populate per avere direttamente i devices legati ad ogni purchase (necessario per mostrare Dispositivi/Accessori nel tab vendite V2)
populateParamsPatient += "&populate[9]=purchases.devices.lot";
populateParamsPatient += "&populate[10]=purchases.devices.lot.product";

SchedaPazienteService.getSchedaPaziente = function (id) {
    return fetch({
        url: `/api/patients/${id}?${populateParamsPatient}`,
        method: 'GET'
    })
}
SchedaPazienteService.getSalesPatient = function (id) {
    return fetch({
        url: `/api/patients/${id}?fields[0]=id&${populateParamsPatient}`,
        method: 'GET'
    })
}
SchedaPazienteService.putSchedaPaziente = function (id, data) {
    return fetch({
        url: `/api/patients/${id}?${populateParamsPatient}`,
        method: 'PUT',
        data: data
    })
}

SchedaPazienteService.postVisita = function (data) {
    return fetch({
        url: `/api/visits`,
        method: 'POST',
        data: data
    })
}

SchedaPazienteService.putVisita = function (id, data) {
    return fetch({
        url: `/api/visits/${id}`,
        method: 'PUT',
        data: data
    })
}

SchedaPazienteService.deleteVisita = function (id) {
    return fetch({
        url: `/api/visits/${id}`,
        method: 'DELETE'
    })
}

SchedaPazienteService.getCronologia = function (id) {
    return fetch({
        url: `/api/patients/${id}?fields=cronologia`,
        method: 'GET',
    })
}

SchedaPazienteService.aggiornaCronologia = function (id, data) {
    return fetch({
        url: `/api/patients/${id}`,
        method: 'PUT',
        data: data
    })
}
/* GESTIONE STATO PAZIENTE */

SchedaPazienteService.putStatoPaziente = function (data) {
    return fetch({
        url: `/api/state-type-patients?populate[0]=patient.state_type_patients.purchase&populate[1]=patient.stores&populate[2]=patient.purchases.state_type_patient&populate[3]=patient.purchases.sales_histories`,
        method: 'POST',
        data: data
    })
}
SchedaPazienteService.modifyStatoPaziente = function (id,data) {
    return fetch({
        url: `/api/state-type-patients/${id}?populate[0]=patient.state_type_patients.purchase&populate[1]=patient.stores&populate[2]=patient.purchases.state_type_patient&populate[3]=patient.purchases.sales_histories`,
        method: 'PUT',
        data: data
    })
}
SchedaPazienteService.deleteStatoPaziente = function (id) {
    return fetch({
        url: `/api/state-type-patients/${id}`,
        method: 'DELETE',
    })
}

SchedaPazienteService.getPazientiAfterDelete = function (id) {
    return fetch({
        url: `/api/patients/${id}?populate[0]=state_type_patients.purchase&populate[1]=stores&populate[2]=purchases.sales_histories`,
        method: 'GET',

    })
}
export default SchedaPazienteService;